// extracted by mini-css-extract-plugin
module.exports = {"popover-trigger":"style_popover-trigger__9VM90"};